import { useAFormHandler } from 'analytics/hooks'
import { useFormik } from 'formik'
import { endpoints } from 'modules/endpoints'
import { apiClient } from 'modules/utils/httpClient'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import ADefaultModalFooter from 'views/components/DefaultModalFooter/ADefaultModalFooter'
import FormSelectShared from 'views/components/FormSelectShared'
import { SharedModalContent, SharedModalInputs, SharedModalTitle } from 'views/components/SharedModal'
import ASharedModal from 'views/components/SharedModal/ASharedModal'
import { AnalyticsPlaces } from '../../analyticsPlaces'

interface Props {
  ids: string[]
  deal_id: string
  onClose: () => void
  onSuccess: () => void
}

type Fields = {
  logisticians: string[]
}
export const EditLogisticianModal: FC<Props> = ({ ids, deal_id, onClose, onSuccess }) => {
  const { t } = useTranslation('dispatching')
  const { formProgress, formHandler } = useAFormHandler()

  const formik = useFormik<Fields>({
    initialValues: {
      logisticians: ids,
    },
    onSubmit: formHandler(async () => await apiClient.put<Fields>(endpoints.executorsEdit(deal_id), formik.values), {
      onSuccess: async () => {
        await onSuccess()
        onClose()
      },
      onError: (error) => {
        const { errors } = error
        formik.setErrors(errors)
      },
    }),
  })

  return (
    <ASharedModal id={AnalyticsPlaces.EDIT_LOGISTIAN_MODAL} onClose={onClose} size="small">
      <SharedModalTitle>{t('modal.editLogisticianTitle')}</SharedModalTitle>
      <SharedModalContent>
        <SharedModalInputs>
          <FormSelectShared
            hideLabel
            formik={formik}
            endpoint={endpoints.dispatchingLogisticians()}
            fieldName="logisticians"
            getLabel={(dto) => dto.full_name}
            multiple
            searchField="search"
          />
        </SharedModalInputs>
      </SharedModalContent>
      <ADefaultModalFooter
        onClose={onClose}
        disabled={!formik.dirty}
        confirmButtonText={t('common:save')}
        progress={formProgress}
        onConfirm={() => formik.submitForm()}
      />
    </ASharedModal>
  )
}
